export default "__VITE_ASSET__74db9e1c__"